import { render, staticRenderFns } from "./PortalModal.vue?vue&type=template&id=7bdb1d50&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCloseForm: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/CloseForm.vue').default})
